<template>
	<div>
		<div
			v-if="isBlockShown"
			:class="'panel programm_schedule ' +
				(isHeaderIndent? ' mt-0 pt-1 ' : '') +
				(isFooterIndent? ' mb-0 pb-1 ' : '') +
				block.appearance"
		>
			<div
				class="container"
				:class="[
					isBrand? 'sk' : '',
				]"
			>
				<div v-if="isHeaderVisible" class="panel_header">
					<h2 class="mb-3">
						{{ block.block_title }}
					</h2>
				</div>
				<div class="panel_header">
					<slides-menu-block
						v-if="hasTabs"
						v-model="tab"
						:items="tabs"
						disable-all
					/>
				</div>

				<ul v-if="block.accordion !==null && block.accordion === 1" class="program_accordeon_list">
					<li
						v-for="(item, index) in block.blocks[tab].content"
						:key="index"
						class="row d-flex align-self-center justify-content-start"
					>
						<div class="col-12 col-lg-3">
							<div class="module_data">
								<div v-if="item.title" class="title">
									{{ item.title }}
								</div>
								<div v-if="item.custom_date !==null" class="description">
									<span>{{ item.custom_date }}</span>
								</div>
								<div v-else-if="item.date_start" class="description">
									<span>{{ item.date_start | moment('DD MMMM YYYY') }}</span> -
									<span>{{ item.date_end | moment('DD MMMM YYYY') }}</span>
								</div>
								<div v-if="item.location !==null" class="description mt-2" v-html="item.location" />
							</div>
						</div>

						<div class="col-12 col-lg-9">
							<div
								v-for="(sub_item, sub_index) in item.content"
								:key="sub_index"
								class="module_item"
							>
								<div class="theme" />
								<div v-if="sub_item.name" class="title">
									{{ sub_item.name }}
								</div>
								<peopleLine v-if="sub_item.speakers.length" :items="sub_item.speakers" />
								<div class="description">
									<p v-if="'description' in sub_item">
										{{ sub_item.description }}
									</p>
								</div>
								<client-only>
									<b-collapse :id="'module-collapse-' + index">
										<div class="row">
											<div v-if="sub_item.answer" class="content col-12 col-lg" v-html="sub_item.answer" />
											<div v-if="sub_item.answer_alumni" class="content col-12 col-lg-5">
												<div
													class="content"
													v-html="sub_item.answer_alumni"
												/>
											</div>
										</div>
									</b-collapse>
									<div v-if="item.button && item.products.length > 0">
										<div
											v-if="isRestriction(item.products[sub_index])"
											class="d-flex align-items-center mb-4"
										>
											<dynamic-button
												:button="item.button"
												:block-id="item.id"
												:scenario="item.button.button_scenario"
												:item="item.products[sub_index]"
												@select="selectItem"
											/>
											<span class="ml-2">
												{{ `Доступно ${item.products[sub_index].quantity_restriction - item.products[sub_index].attached_count} из ${item.products[sub_index].quantity_restriction} мест` }}
											</span>
										</div>
										<div
											v-else-if="item.products[sub_index].is_user_quantity_restriction_enabled === 1
												&& !isUserRestrictionEnable(item.products[sub_index])"
										>
											Заявка на модуль отправлена
										</div>
										<div
											v-else-if="item.products[sub_index].is_quantity_restriction_enabled === 1
												&& item.products[sub_index].attached_count >= item.products[sub_index].quantity_restriction"
										>
											Набор на данный модуль завершен
										</div>
									</div>
									<dynamic-button
										v-else-if="item.button"
										:button="item.button"
										:block-id="item.id"
										:scenario="item.button.button_scenario"
									/>
								</client-only>
							</div>
						</div>

						<div class="col-12">
							<div class="module_footer">
								<b-button
									v-b-toggle="'module-collapse-' + index"
									v-b-tooltip.hover
									variant="resize"
									class="icon-chevron"
									:title="$t('moreDetails')"
								/>
							</div>
						</div>
					</li>
				</ul>

				<!-- Вариант - не расхлоп -->
				<ul v-else class="program_list">
					<li
						v-for="(item, index) in block.blocks[tab].content"
						:key="index"
						class="row d-flex align-self-center justify-content-start"
					>
						<div class="col-12 col-sm-12 col-lg-12">
							<div class="row schedule_data">
								<div class="col-12 col-md-4">
									<div class="module_data">
										<div v-if="item.title" class="title">
											{{ item.title }}
										</div>
										<div v-if="item.custom_date !==null" class="description">
											<span>{{ item.custom_date }}</span>
										</div>
										<div v-else-if="item.date_start" class="description">
											<span>{{ item.date_start | moment('DD MMMM YYYY') }}</span> -
											<span>{{ item.date_end | moment('DD MMMM YYYY') }}</span>
										</div>
										<div
											v-if="item.location !==null"
											class="description mt-2"
											v-html="item.location"
										/>
									</div>
								</div>
								<div class="col-12 col-md-8">
									<div v-for="(sub_item, sub_index) in item.content" :key="sub_index" class="module_item">
										<div v-if="sub_item.name" class="title">
											{{ sub_item.name }}
										</div>

										<div class="row">
											<div v-if="sub_item.answer" class="content col-12" v-html="sub_item.answer" />
											<peopleLine v-if="sub_item.speakers.length" class="col-12" :items="sub_item.speakers" />
											<div v-if="sub_item.answer_alumni" class="content col-12 col-lg-12">
												<div
													class="content"
													v-html="sub_item.answer_alumni"
												/>
											</div>
										</div>
										<div>
											<div v-if="item.button && item.products.length > 0">
												<div
													v-if="isRestriction(item.products[sub_index])"
													class="d-flex align-items-center mb-4"
												>
													<dynamic-button
														:button="item.button"
														:block-id="item.id"
														:scenario="item.button.button_scenario"
														:item="item.products[sub_index]"
														@select="selectItem"
													/>
													<span class="ml-2">
														{{ `Доступно ${item.products[sub_index].quantity_restriction - item.products[sub_index].attached_count} из ${item.products[sub_index].quantity_restriction} мест` }}
													</span>
												</div>
												<div
													v-else-if="item.products[sub_index].is_user_quantity_restriction_enabled === 1
														&& !isUserRestrictionEnable(item.products[sub_index])"
												>
													Заявка на модуль отправлена
												</div>
												<div
													v-else-if="item.products[sub_index].is_quantity_restriction_enabled === 1
														&& item.products[sub_index].attached_count >= item.products[sub_index].quantity_restriction"
												>
													Набор на данный модуль завершен
												</div>
											</div>
											<dynamic-button
												v-else-if="item.button"
												:button="item.button"
												:block-id="item.id"
												:scenario="item.button.button_scenario"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
				</ul>

				<div v-if="isFooterVisible" class="panel_footer">
					<div class="row">
						<div class="col-12">
							<dynamic-button
								v-if="block.button"
								:button="block.button"
								:block-id="block.id"
								:scenario="block.button.button_scenario"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="block.is_alumni_block === 3 && !block.alumni_and_loyalty_check" class="d-flex container">
			<div class="mt-5 mb-5 title">
				Привилегии от партнеров доступны участникам уровней Gold, Platinum и Diamond
			</div>
		</div>
	</div>
</template>

<script>
import '@/utils/moment';
import panel from '~/mixins/panel';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import SlidesMenuBlock from '~/components/refactor/SlidesMenuBlock.vue';
import checkIsBlockShown from '~/mixins/checkIsBlockShown';
import PeopleLine from '~/components/blocks/people/NewPeopleLine.vue';

export default {
	name: 'PanelSc01',
	components: {
		SlidesMenuBlock,
		PeopleLine,
	},
	directives: {
		swiper: directive,
	},
	mixins: [panel, checkIsBlockShown],
	data() {
		return {
			tab: '0',
			options: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				cssMode: true,
				loop: false,
			},
			modules: [],
		};
	},
	computed: {
		hasTabs() {
			return Array.isArray(this.block.blocks) && this.block.blocks.length > 0;
		},
		tabs() {
			if (!this.hasTabs) return null;

			const t = {};
			// eslint-disable-next-line camelcase
			this.block.blocks.forEach(({ title }, index) => {
				// eslint-disable-next-line camelcase
				t[index] = title;
			});
			return t;
		},
	},
	created() {
		if (this.block.is_select_products_by_tabs) {
			this.modules = Array(this.block.blocks.length).fill(null);
		}
	},
	methods: {
		isRestriction(product) {
			if (product.is_user_quantity_restriction_enabled === 1
				&& !this.isUserRestrictionEnable(product)) return false;

			if (product.is_quantity_restriction_enabled === 1
				&& product.attached_count >= product.quantity_restriction) return false;
			return true;
		},
		isUserRestrictionEnable(product) {
			if (product.users && product.users.length > 0) {
				return product.user_quantity_restriction
					> product.users.find((el) => el.id == this.$auth.user.id).pivot.count;
			}
			return true;
		},
		selectItem(product) {
			let products = [];
			if (this.block.is_select_products_by_tabs) {
				this.modules[this.tab] = product;
				products = this.modules.filter((el) => !!el).map((el) => `${el.name};${el.id}`);
			} else {
				products = [`${product.name};${product.id}`];
			}

			this.$router.push({
				query: {
					...this.$route.query,
					products,
				},
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/home/panel-explist";
@import "~/assets/styles/components/home/panel-schedule";

.programm_schedule {
	// margin-top: 3rem;
	.panel_footer {
		margin-top: 1.5rem;
	}

	.title {
		margin-bottom: 1rem;
	}

	.schedule_list {
		border-bottom: 1px solid $body-color; // margin-bottom: 3rem;
	}

	.schedule_time {
		margin-bottom: 1rem;
		height: auto;
	}
}
</style>
